export default "__VITE_ASSET__BebScHo6__"